/* LUVRIAN theme JS — no dependencies. */
(function () {
  'use strict';

  var L = (window.LUVRIAN = window.LUVRIAN || {});
  var routes = L.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var strings = L.strings || {};
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ analytics */
  L.track = function (event, data) {
    var cfg = L.analytics || {};
    data = data || {};
    try {
      if (cfg.dataLayer !== false) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: event, lv: data, ecommerce: data.items ? data : undefined });
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, data);
      }
      if (cfg.debug) console.info('[LUVRIAN]', event, data);
    } catch (e) { /* analytics must never break shopping */ }
  };

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (el) L.track(el.getAttribute('data-track'), { label: (el.getAttribute('data-track-label') || el.textContent || '').trim().slice(0, 80), section: el.closest('[data-section-id]') ? el.closest('[data-section-id]').getAttribute('data-section-id') : null });
  });

  /* ------------------------------------------------------------ helpers */
  function money(cents) {
    var format = (L.settings && L.settings.moneyFormat) || '${{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var value = (cents / 100).toFixed(2);
    function withDelimiters(num, thousands, decimal, precision) {
      var parts = Number(num).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(value, ',', '.', 2);
        case 'amount_no_decimals': return withDelimiters(value, ',', '.', 0);
        case 'amount_with_comma_separator': return withDelimiters(value, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return withDelimiters(value, "'", '.', 2);
        default: return withDelimiters(value, ',', '.', 2);
      }
    });
  }
  L.money = money;

  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 3200);
  }
  L.toast = toast;

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Request failed'); err.data = j; throw err; }
        return j;
      });
    });
  }

  /* ------------------------------------------------------------ cart */
  var Cart = (L.cart = {
    sectionIds: function () {
      var ids = [];
      document.querySelectorAll('[data-cart-section]').forEach(function (el) { ids.push(el.getAttribute('data-cart-section')); });
      return ids;
    },
    renderSections: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-cart-section="' + id + '"]').forEach(function (target) {
          var fresh = doc.querySelector('[data-cart-section="' + id + '"]');
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      });
      Cart.refreshCount();
    },
    refreshCount: function () {
      return fetchJSON(routes.cart + '.js').then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      }).catch(function () {});
    },
    add: function (items, meta) {
      var sections = Cart.sectionIds();
      var body = { items: items };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
      return fetchJSON(routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify(body) }).then(function (res) {
        Cart.renderSections(res.sections);
        var added = res.items || [res];
        L.track((meta && meta.event) || 'lv_add_to_cart', {
          currency: (L.analytics || {}).currency,
          value: added.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100,
          source: meta && meta.source,
          items: added.map(function (i) { return { item_id: i.sku || String(i.variant_id), item_name: i.product_title, item_variant: i.variant_title, price: i.final_price / 100, quantity: i.quantity }; })
        });
        if ((L.settings || {}).cartType === 'page') {
          window.location.href = routes.cart;
        } else {
          Cart.open();
        }
        return res;
      });
    },
    change: function (key, quantity) {
      var sections = Cart.sectionIds();
      return fetchJSON(routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity: quantity, sections: sections, sections_url: window.location.pathname })
      }).then(function (res) {
        Cart.renderSections(res.sections);
        if (quantity === 0) L.track('lv_remove_from_cart', { key: key });
        return res;
      });
    },
    open: function () {
      var d = document.querySelector('[data-cart-drawer]');
      if (!d) { window.location.href = routes.cart; return; }
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      Cart._lastFocus = document.activeElement;
      var close = d.querySelector('[data-drawer-close]');
      if (close) setTimeout(function () { close.focus(); }, 50);
      L.track('lv_view_cart', { source: 'drawer' });
    },
    close: function () {
      var d = document.querySelector('[data-cart-drawer]');
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (Cart._lastFocus) Cart._lastFocus.focus();
    }
  });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && (L.settings || {}).cartType !== 'page' && document.querySelector('[data-cart-drawer]')) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Cart.close(); return; }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var line = qtyBtn.closest('[data-line-key]');
      var input = line.querySelector('input');
      var q = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-cart-qty'), 10));
      line.style.opacity = '.5';
      Cart.change(line.getAttribute('data-line-key'), q).catch(function (err) { toast(err.message); line.style.opacity = ''; });
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var l2 = rm.closest('[data-line-key]');
      l2.style.opacity = '.5';
      Cart.change(l2.getAttribute('data-line-key'), 0).catch(function (err) { toast(err.message); });
      return;
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      Cart.add([{ id: Number(quick.getAttribute('data-quick-add')), quantity: 1 }], { source: quick.getAttribute('data-source') || 'quick_add', event: quick.getAttribute('data-event') || 'lv_add_to_cart' })
        .catch(function (err) { toast(err.message || strings.error); })
        .finally(function () { quick.classList.remove('is-loading'); });
      return;
    }
    var checkout = e.target.closest('[data-checkout]');
    if (checkout) L.track('lv_begin_checkout', { source: checkout.getAttribute('data-checkout') });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-input]');
    if (input) {
      var line = input.closest('[data-line-key]');
      Cart.change(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0)).catch(function (err) { toast(err.message); });
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) fetchJSON((routes.cartUpdate || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ note: note.value }) }).catch(function () {});
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { Cart.close(); closeMenu(); }
    var d = document.querySelector('[data-cart-drawer].is-open');
    if (e.key === 'Tab' && d) {
      var f = d.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------ product form */
  function ProductForm(root) {
    this.root = root;
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    this.form = root.querySelector('form[data-product-form]');
    this.variantInput = root.querySelector('[data-variant-id]');
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.submit = root.querySelector('[data-add-button]');
    this.updateUrl = root.hasAttribute('data-update-url');
    this.bind();
    this.onVariantChange(false);
  }
  ProductForm.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) self.onVariantChange(true);
      if (e.target.matches('[data-offer-input]')) {
        var q = parseInt(e.target.getAttribute('data-qty'), 10) || 1;
        if (self.qtyInput) self.qtyInput.value = q;
        self.updateButtonPrice();
        L.track('lv_select_offer', { quantity: q });
      }
      if (e.target.matches('[data-addon-input]')) { self.updateButtonPrice(); L.track(e.target.checked ? 'lv_addon_selected' : 'lv_addon_removed', { variant: e.target.value }); }
      if (e.target.matches('[data-qty-input]')) self.updateButtonPrice();
    });
    this.root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step && self.qtyInput) {
        e.preventDefault();
        var v = Math.max(1, (parseInt(self.qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
        self.qtyInput.value = v;
        self.syncOffers(v);
        self.updateButtonPrice();
      }
    });
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
  };
  ProductForm.prototype.getQty = function () {
    if (this.qtyInput) return Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
    var offer = this.root.querySelector('[data-offer-input]:checked');
    return offer ? Math.max(1, parseInt(offer.getAttribute('data-qty'), 10) || 1) : 1;
  };
  ProductForm.prototype.selectedOptions = function () {
    var opts = [];
    this.root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var checked = group.querySelector('input:checked');
      var select = group.querySelector('select');
      opts[idx] = checked ? checked.value : select ? select.value : null;
    });
    return opts;
  };
  ProductForm.prototype.currentVariant = function () {
    var opts = this.selectedOptions();
    if (!opts.length) {
      var id = this.variantInput && Number(this.variantInput.value);
      return this.product.variants.find(function (v) { return v.id === id; }) || this.product.variants[0];
    }
    return this.product.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); });
  };
  ProductForm.prototype.onVariantChange = function (userAction) {
    var v = this.currentVariant();
    this.variant = v;
    var root = this.root;
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var label = group.querySelector('[data-option-value]');
      var checked = group.querySelector('input:checked');
      if (label && checked) label.textContent = checked.value;
      if (label && !checked && v) label.textContent = v.options[idx];
    });
    if (!v) { this.setButton(false, strings.unavailable || 'Unavailable'); return; }
    if (this.variantInput) this.variantInput.value = v.id;
    root.querySelectorAll('[data-price-current]').forEach(function (el) { el.textContent = money(v.price); });
    root.querySelectorAll('[data-price-compare]').forEach(function (el) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      el.hidden = !sale;
      el.textContent = sale ? money(v.compare_at_price) : '';
    });
    root.querySelectorAll('[data-price-save]').forEach(function (el) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      el.hidden = !sale;
      if (sale) el.textContent = (el.getAttribute('data-save-template') || 'Save {amount}').replace('{amount}', money(v.compare_at_price - v.price));
    });
    root.querySelectorAll('[data-sku]').forEach(function (el) { el.textContent = v.sku || ''; });
    root.querySelectorAll('[data-offer-input]').forEach(function (o) {
      var p = o.parentNode.querySelector('.offer-tier__price');
      if (p) p.textContent = money(v.price * (parseInt(o.getAttribute('data-qty'), 10) || 1));
    });
    this.updateStock(v);
    this.setButton(v.available, v.available ? null : strings.soldOut);
    this.updateButtonPrice();
    if (v.featured_media && userAction) {
      var g = document.querySelector('[data-gallery="' + root.getAttribute('data-section-id') + '"]');
      if (g && g._gallery) g._gallery.goToMedia(v.featured_media.id);
    }
    if (this.updateUrl && userAction && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    document.querySelectorAll('[data-sticky-for="' + root.getAttribute('data-section-id') + '"] [data-sticky-variant]').forEach(function (s) { s.value = v.id; });
    if (userAction) L.track('lv_select_variant', { item_id: v.sku || String(v.id), item_variant: v.title, price: v.price / 100 });
  };
  ProductForm.prototype.updateStock = function (v) {
    var el = this.root.querySelector('[data-low-stock]');
    if (!el) return;
    var inv = (this.root.querySelector('[data-inventory]') ? JSON.parse(this.root.querySelector('[data-inventory]').textContent) : {})[v.id];
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    if (inv && inv.managed && inv.qty > 0 && inv.qty <= threshold) {
      el.hidden = false;
      el.querySelector('[data-low-stock-text]').textContent = (el.getAttribute('data-template') || 'Only {count} left').replace('{count}', inv.qty);
    } else {
      el.hidden = true;
    }
  };
  ProductForm.prototype.setButton = function (enabled, text) {
    var btns = [this.submit].concat(Array.prototype.slice.call(document.querySelectorAll('[data-sticky-for="' + this.root.getAttribute('data-section-id') + '"] [data-sticky-add]')));
    btns.forEach(function (b) {
      if (!b) return;
      b.disabled = !enabled;
      var label = b.querySelector('.btn__label');
      if (label) {
        if (!b.hasAttribute('data-default-label')) b.setAttribute('data-default-label', label.textContent);
        label.textContent = text || b.getAttribute('data-default-label');
      }
    });
  };
  ProductForm.prototype.addonItems = function () {
    var items = [];
    this.root.querySelectorAll('[data-addon-input]:checked').forEach(function (i) { items.push({ id: Number(i.value), quantity: 1, price: Number(i.getAttribute('data-price')) || 0 }); });
    return items;
  };
  ProductForm.prototype.updateButtonPrice = function () {
    if (!this.variant) return;
    var qty = this.getQty();
    var total = this.variant.price * qty;
    var compare = (this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price) ? this.variant.compare_at_price * qty : 0;
    this.addonItems().forEach(function (a) { total += a.price; if (compare) compare += a.price; });
    var targets = [this.root].concat(Array.prototype.slice.call(document.querySelectorAll('[data-sticky-for="' + this.root.getAttribute('data-section-id') + '"]')));
    targets.forEach(function (t) {
      t.querySelectorAll('[data-button-price]').forEach(function (el) { el.innerHTML = money(total) + (compare ? ' <s>' + money(compare) + '</s>' : ''); });
    });
    this.syncOffers(qty);
  };
  ProductForm.prototype.syncOffers = function (qty) {
    var match = this.root.querySelector('[data-offer-input][data-qty="' + qty + '"]');
    if (match && !match.checked) match.checked = true;
  };
  ProductForm.prototype.addToCart = function () {
    var self = this;
    if (!this.variant || !this.variant.available) return;
    var qty = this.getQty();
    var items = [{ id: this.variant.id, quantity: qty }];
    var props = {};
    this.root.querySelectorAll('[data-line-property]').forEach(function (i) { if (i.value) props[i.name.replace(/^properties\[|\]$/g, '')] = i.value; });
    if (Object.keys(props).length) items[0].properties = props;
    this.addonItems().forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
    this.submit && this.submit.classList.add('is-loading');
    Cart.add(items, { source: this.root.getAttribute('data-source') || 'product_form' })
      .catch(function (err) { toast(err.message || strings.error); })
      .finally(function () { self.submit && self.submit.classList.remove('is-loading'); });
  };
  L.ProductForm = ProductForm;

  /* sticky add to cart */
  function initSticky(bar) {
    var sectionId = bar.getAttribute('data-sticky-for');
    var anchor = document.querySelector('[data-section-id="' + sectionId + '"] [data-add-button]');
    var form = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!anchor || !form) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !en.isIntersecting && below);
        bar.setAttribute('aria-hidden', en.isIntersecting || !below ? 'true' : 'false');
      });
    });
    io.observe(anchor);
    bar.addEventListener('change', function (e) {
      if (e.target.matches('[data-sticky-variant]')) {
        var id = Number(e.target.value);
        var pf = form._productForm;
        if (!pf) return;
        var v = pf.product.variants.find(function (x) { return x.id === id; });
        if (!v) return;
        v.options.forEach(function (val, i) {
          var group = form.querySelector('[data-option-index="' + i + '"]');
          if (!group) return;
          var radio = group.querySelector('input[value="' + CSS.escape(val) + '"]');
          if (radio) radio.checked = true;
          var sel = group.querySelector('select');
          if (sel) sel.value = val;
        });
        pf.onVariantChange(true);
      }
    });
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        e.preventDefault();
        var pf = form._productForm;
        if (pf) pf.addToCart();
      }
    });
  }

  /* ------------------------------------------------------------ gallery */
  function Gallery(root) {
    this.root = root;
    this.track = root.querySelector('[data-gallery-slides]');
    if (!this.track) return;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var self = this;
    this.index = 0;
    this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
    this.dots.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
    var t;
    this.track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        if (i !== self.index) self.setActive(i);
      }, 60);
    }, { passive: true });
    root._gallery = this;
  }
  Gallery.prototype.go = function (i) {
    var n = this.slides.length;
    i = (i + n) % n;
    this.track.scrollTo({ left: this.track.clientWidth * i, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    this.setActive(i);
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    var i = this.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
    if (i > -1) this.go(i);
  };
  Gallery.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    this.dots.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    this.slides.forEach(function (s, k) {
      var v = s.querySelector('video');
      if (v && k !== i) v.pause();
    });
  };

  /* ------------------------------------------------------------ bundle */
  function Bundle(root) {
    var self = this;
    this.root = root;
    root.addEventListener('change', function () { self.update(); });
    var btn = root.querySelector('[data-bundle-add]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var items = [];
      root.querySelectorAll('[data-bundle-select]').forEach(function (s) {
        var opt = s.options ? s.options[s.selectedIndex] : null;
        var id = s.value;
        if (id && (!opt || !opt.disabled)) items.push({ id: Number(id), quantity: 1 });
      });
      if (!items.length) return;
      btn.classList.add('is-loading');
      Cart.add(items, { source: 'bundle', event: 'lv_add_bundle_to_cart' })
        .catch(function (err) { toast(err.message || strings.error); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
    this.update();
  }
  Bundle.prototype.update = function () {
    var total = 0, ok = true;
    this.root.querySelectorAll('[data-bundle-select]').forEach(function (s) {
      var opt = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s;
      total += Number(opt.getAttribute('data-price')) || 0;
      if (opt.hasAttribute('data-unavailable')) ok = false;
    });
    this.root.querySelectorAll('[data-bundle-total]').forEach(function (el) { el.textContent = money(total); });
    var btn = this.root.querySelector('[data-bundle-add]');
    if (btn) btn.disabled = !ok;
  };

  /* ------------------------------------------------------------ countdown (real dates only) */
  function Countdown(el) {
    var end = el.getAttribute('data-countdown');
    if (!end) { el.hidden = true; return; }
    // Date-only strings count down to local midnight of that day.
    var target = /^\d{4}-\d{2}-\d{2}$/.test(end) ? new Date(end + 'T00:00:00') : new Date(end);
    if (isNaN(target)) { el.hidden = true; return; }
    var parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    var hideWhenDone = el.hasAttribute('data-hide-expired');
    var container = el.closest('[data-countdown-container]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = target - new Date();
      if (diff <= 0) {
        clearInterval(timer);
        if (hideWhenDone) (container || el).hidden = true;
        var exp = container && container.querySelector('[data-countdown-expired]');
        if (exp) { exp.hidden = false; el.hidden = true; }
        return;
      }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      if (parts.d) parts.d.textContent = d;
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(s);
      el.querySelectorAll('[data-days-text]').forEach(function (t) { t.textContent = d; });
    }
    var timer = setInterval(tick, 1000);
    tick();
    el.hidden = false;
  }

  /* ------------------------------------------------------------ compare slider */
  function Compare(root) {
    var range = root.querySelector('[data-compare-range]');
    if (!range) return;
    var set = function () { root.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', set);
    range.addEventListener('change', function () { L.track('lv_glow_compare', { position: Number(range.value) }); }, { once: true });
    set();
    if (root.hasAttribute('data-compare-intro') && !prefersReducedMotion) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        var start = null, from = 88, to = Number(range.value);
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1600);
          var e = 0.5 - Math.cos(Math.PI * p) / 2;
          range.value = from + (to - from) * e;
          set();
          if (p < 1) requestAnimationFrame(step);
        }
        range.value = from; set();
        requestAnimationFrame(step);
      }, { threshold: 0.5 });
      io.observe(root);
    }
  }

  /* ------------------------------------------------------------ videos */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-lv-autoplay]');
    if (!vids.length) return;
    if (prefersReducedMotion) {
      vids.forEach(function (v) { v.removeAttribute('data-lv-autoplay'); v.controls = true; v.preload = 'metadata'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); io.observe(v); });
  }
  document.addEventListener('play', function (e) {
    if (e.target.tagName === 'VIDEO' && !e.target.hasAttribute('data-lv-autoplay')) L.track('lv_video_play', { src: (e.target.currentSrc || '').split('/').pop().split('?')[0] });
  }, true);

  /* ------------------------------------------------------------ reveal */
  function initReveal() {
    if (!document.body.classList.contains('reveal-enabled') || prefersReducedMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ header / menu */
  function closeMenu() {
    var m = document.querySelector('[data-mobile-menu].is-open');
    if (!m) return;
    m.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    var t = document.querySelector('[data-menu-toggle]');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var m = document.querySelector('[data-mobile-menu]');
      if (!m) return;
      m.classList.add('is-open');
      document.body.classList.add('drawer-open');
      t.setAttribute('aria-expanded', 'true');
      var c = m.querySelector('[data-menu-close]');
      if (c) c.focus();
      return;
    }
    if (e.target.closest('[data-menu-close]') || (e.target.closest('[data-mobile-menu] a'))) closeMenu();
  });
  function initHeader() {
    var h = document.querySelector('[data-sticky-header]');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------ tabs (faq) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var root = tab.closest('[data-tabs]');
    root.querySelectorAll('[data-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    root.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== tab.getAttribute('data-tab'); });
  });
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('details[data-track-open]') && e.target.open) L.track('lv_faq_open', { question: (e.target.querySelector('summary') || {}).textContent.trim().slice(0, 100) });
  }, true);

  /* ------------------------------------------------------------ lightbox */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-lightbox]');
    if (!trig) return;
    e.preventDefault();
    var dlg = document.querySelector('[data-lightbox-dialog]');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'lightbox';
      dlg.setAttribute('data-lightbox-dialog', '');
      dlg.innerHTML = '<button class="icon-btn lightbox__close" type="button" aria-label="Close" style="background:#fff;color:#111"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div data-lightbox-content></div>';
      document.body.appendChild(dlg);
      dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { dlg.querySelector('[data-lightbox-content]').innerHTML = ''; });
    }
    var src = trig.getAttribute('data-lightbox');
    var isVideo = /\.mp4(\?|$)/.test(src);
    dlg.querySelector('[data-lightbox-content]').innerHTML = isVideo ? '<video src="' + src + '" controls autoplay playsinline></video>' : '<img src="' + src + '" alt="' + (trig.getAttribute('data-alt') || '') + '">';
    if (dlg.showModal) dlg.showModal();
    L.track('lv_media_open', { src: src.split('/').pop().split('?')[0] });
  });

  /* ------------------------------------------------------------ newsletter */
  function initAnnouncement() {
    document.querySelectorAll('[data-rotator]').forEach(function (r) {
      var slides = r.querySelectorAll('.announcement__slide');
      if (slides.length < 2 || prefersReducedMotion) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, (parseInt(r.getAttribute('data-rotator'), 10) || 5) * 1000);
    });
  }

  /* ------------------------------------------------------------ init */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-product-root]').forEach(function (el) { if (!el._productForm) el._productForm = new ProductForm(el); });
    scope.querySelectorAll('[data-gallery]').forEach(function (el) { if (!el._gallery) new Gallery(el); });
    scope.querySelectorAll('[data-sticky-for]').forEach(function (el) { if (!el._sticky) { el._sticky = true; initSticky(el); } });
    scope.querySelectorAll('[data-bundle]').forEach(function (el) { if (!el._bundle) el._bundle = new Bundle(el); });
    scope.querySelectorAll('[data-countdown]').forEach(function (el) { if (!el._cd) { el._cd = true; Countdown(el); } });
    scope.querySelectorAll('[data-compare]').forEach(function (el) { if (!el._cmp) { el._cmp = true; Compare(el); } });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    initVideos();
    initReveal();
    initHeader();
    initAnnouncement();
  });

  // Theme editor support: re-init sections when they are added or changed.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initVideos();
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) Cart.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) Cart.close();
  });
})();
